import { Routes } from '@angular/router';
import { logRedirectGuard, RmaEmptyComponent } from '@rma/dashboard/generic/util/router-utils';
import { communicationRoutes } from './communication.routes';

export const redirectRoutes: Routes = [
  // Redirects

  // Remove after 2024-06-30
  {
    path: 'communication',
    children: communicationRoutes,
  },
  // Remove after 2024-06-30
  {
    path: 'reporting',
    canActivate: [logRedirectGuard('/monitoring/online-performance')],
    component: RmaEmptyComponent,
  },
];
